import {
  FC,
  CSSProperties,
  useState,
  useRef,
  ReactNode,
  useEffect,
  Key,
  useCallback,
  MutableRefObject,
} from 'react';
// import { Select } from 'antd';
import { ProSelect } from '../antd';
import ModalTable, { ModalTableType } from '../ModalTable/modalTable';
import { SuperFormItemProps } from '../SuperForm';
import { SearchFormOperationProps } from '../SearchForm/operation';
import { columnsProps, IGroupField, TableActionType } from '../SuperTable/interface';
import {
  SUCCESS_STATUS_CODE,
  MAX_TAG_TEXT_LENGTH,
} from '../constants/constant';
import { FormInstance } from 'antd/lib/form';
import { RenderDOMFunc } from '../constants/interface';
import styles from './style.module.less';

export type methodType = 'POST' | 'GET';
export type rowSelectionType = 'radio' | 'checkbox';
export type defaultValueType = Key | Key[] | undefined;
interface IFetch {
  fetchApi: (params: any) => Promise<any>;
  timer: MutableRefObject<any>;
  value?: string;
  otherParams?: any;
  searchKey: string;
  dataKey?: string | false;
  isTableList?: boolean;
  selectTableKey?: string;
  callback?: (data: any[]) => void;
  beforeFetch?: (values: any) => any;
}
export interface SelectTableProps {
  /** 接口API */
  fetchApi: (params: any) => Promise<any>;
  /** value对应得字段 */
  valueKey: string;
  /** label对应字段 */
  nameKey: string;
  /** 下拉列表标识 用于缓存 可能造成数据更新不及时 */
  selectTableKey?: string;
  /** 自定义样式 */
  style?: CSSProperties;
  /** 自定义类名 */
  className?: string;
  /** 延时  用于防抖 */
  delay?: number;
  /** 更多按钮文字 */
  moreText?: ReactNode;
  /** 列配置 */
  columns?: columnsProps[];
  /** 下拉选项的值对应data的那个字段 */
  dataKey?: string | false;
  /** 额外参数 */
  otherParams?: any;
  /** 是否为表格类型接口 */
  isTableList?: boolean;
  /** 搜索过滤key */
  searchKey?: string;
  /** 是否可以搜索 */
  showSearch?: boolean;
  /** 是否显示清除按钮 */
  allowClear?: boolean;
  /** 单选和多选 */
  mode?: 'multiple' | undefined;
  /** 是否显示更多按钮 */
  showMore?: boolean;
  /** 是否禁用 */
  disabled?: boolean;
  /** 初始默认值 */
  defaultValue?: defaultValueType;
  /** 初始默认key */
  defaultKeys?: Key[];
  /** 初始默认key */
  selectKeys?: Key[];
  /** 表单选中值 */
  value?: defaultValueType;
  /** 更多弹窗大小 */
  modalSize?: ModalTableType;
  /** 列表搜索配置 */
  formItems?: SuperFormItemProps[];
  /** 选择框默认文字 */
  placeholder?: string;
  /** 搜索框操作按钮配置 */
  operationProps?: SearchFormOperationProps;
  /** 下拉菜单的 className 属性 */
  dropdownClassName?: string;
  /** modal弹窗 className 属性 */
  modalClassName?: string;
  /** 初始默认下拉选项 */
  initOptions?: any[];
  /** 最大搜索框数量 */
  maxItemLength?: number;
  /** 最多显示多少个 tag */
  maxTagCount?: number;
  /** 最大显示的 tag 文本长度 */
  maxTagTextLength?: number;
  /** 初始时是否加载 */
  initLoad?: boolean;
  /** 组合字段集合 */
  groupFields?: IGroupField[];
  /** 过滤接口返回数据 */
  filterData?: (data?: any[]) => any[];
  /** 菜单渲染父节点。默认渲染到 body 上 */
  getPopupContainer?: RenderDOMFunc,
  /** value值改变回调 */
  onChange?: (value: any, item: any, form?: FormInstance, index?: number, record?: any) => void;
  /** 获取数据之前回调 */
  beforeFetch?: (params: any, record?: any, index?: number) => any;
  /** 自定义Option选项 */
  renderOption?: (record: any) => ReactNode;
  /** 数据获取成功回调 */
  onSuccess?: (data: any[]) => void;

}

// 获取数据
const fetch = ({
  fetchApi,
  value,
  otherParams,
  searchKey,
  dataKey,
  isTableList,
  selectTableKey,
  timer,
  callback,
  beforeFetch,
}: IFetch) => {
  let searcher = otherParams ? { ...otherParams } : {};
  if (value) searcher[searchKey] = value;
  let params = {};
  if (beforeFetch) {
    searcher = beforeFetch(searcher);
    if (searcher === false || searcher === undefined) return callback?.([]);
  }
  if (isTableList) {
    const pageSize = searcher.pageSize || 20;
    const page = searcher.page || 1;
    delete searcher.page;
    delete searcher.pageSize;
    params = {
      page,
      pageSize,
      searcher,
    };
  } else {
    params = { ...searcher };
  }
  // 判断是否需要从缓存获取数据
  if (selectTableKey && !value) {
    const CACHE_OPTIONS = window.sessionStorage.getItem(selectTableKey);
    if (CACHE_OPTIONS) {
      if (CACHE_OPTIONS === 'loading') {
        timer.current && clearInterval(timer.current);
        timer.current = setInterval(() => {
          const resData = window.sessionStorage.getItem(selectTableKey);
          if (resData && resData !== 'loading') {
            clearInterval(timer.current);
            callback && callback(JSON.parse(resData));
          }
        }, 50);
      } else {
        callback && callback(JSON.parse(CACHE_OPTIONS));
      }
      return;
    } else {
      window.sessionStorage.setItem(selectTableKey, 'loading');
    }
  }
  fetchApi(params).then(res => {
    if (res.code === SUCCESS_STATUS_CODE && res.data) {
      const data = dataKey ? res.data[dataKey] : res.data;
      // 数据存入缓存
      if (selectTableKey && !value)
        window.sessionStorage.setItem(
          selectTableKey,
          JSON.stringify(data || []),
        );
      callback && callback(data || []);
    } else {
      callback && callback([]);
    }
  });
};
/** 下拉列表 */
const SelectTable: FC<SelectTableProps> = props => {
  const {
    style,
    className,
    selectTableKey,
    showSearch,
    fetchApi,
    mode,
    allowClear,
    moreText,
    columns,
    formItems,
    valueKey,
    selectKeys,
    nameKey,
    otherParams,
    searchKey,
    dataKey,
    onChange,
    defaultValue,
    defaultKeys,
    showMore,
    value,
    modalSize,
    operationProps,
    initOptions,
    disabled,
    isTableList,
    delay,
    modalClassName,
    maxItemLength,
    initLoad,
    groupFields,
    getPopupContainer,
    beforeFetch,
    renderOption,
    onSuccess,
    filterData,
    ...resProps
  } = props;
  const fetchTimer = useRef<any>(null);
  const selectRef = useRef<any>(null);
  const tableRef = useRef<TableActionType>();
  const initOptionsCacheRef = useRef<any[]>([]);
  const initRef = useRef<boolean>(false);
  const [visible, setVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [options, setOptions] = useState<any[]>([]);
  const [tableKeys, setTableKeys] = useState<Key[]>(defaultKeys || []);
  const [selectValue, setSelectValue] = useState<defaultValueType>(
    defaultValue ? defaultValue : mode === 'multiple' ? [] : undefined,
  );
  const timer = useRef<any>();
  const valueString = (value && typeof value === 'object') ? JSON.stringify(value) : value;
  const otherParamsString = (otherParams && typeof otherParams === 'object') ? JSON.stringify(otherParams) : otherParams;
  /**
   * 初始化下拉选 选项
   */
  const initSeletOptions = () => {
    initRef.current = true;
    setLoading(true);
    fetch({
      fetchApi,
      value: '',
      otherParams,
      dataKey,
      isTableList,
      selectTableKey,
      timer,
      beforeFetch,
      searchKey: searchKey || valueKey,
      callback: (data: any[]) => {
        setLoading(false);
        const result: any[] = filterData ? filterData(data) : data;
        initOptionsCacheRef.current &&
          initOptionsCacheRef.current.forEach(item => {
            const findOption = result.find(v => v[valueKey] === item[valueKey]);
            if (!findOption) result.unshift(item);
          });
        setOptions(result);
        onSuccess?.(data);
      },
    });
  };
  useEffect(() => {
    initOptionsCacheRef.current = initOptions ?? [];
    initRef.current = false;
    if (!options.length && initOptions?.length) setOptions(initOptions);
  }, [initOptions]);
  useEffect(() => {
    if (value || initLoad) {
      initSeletOptions();
    }
  }, [otherParamsString]);
  useEffect(() => {
    setSelectValue(value ? value : mode === 'multiple' ? [] : undefined);
    setTableKeys(value ? (Array.isArray(value) ? value : [value]) : []);
    if (
      !initRef.current &&
      Array.isArray(initOptions) &&
      initOptions.length &&
      value
    ) {
      initSeletOptions();
    }
  }, [valueString]);
  useEffect(() => {
    if (selectKeys) setTableKeys(selectKeys);
  }, [selectKeys]);
  // 搜索
  const handleSearch = (value: string, delayTime?: number) => {
    if (fetchTimer.current) clearTimeout(fetchTimer.current);
    fetchTimer.current = setTimeout(() => {
      setLoading(true);
      fetch({
        fetchApi,
        value,
        otherParams,
        dataKey,
        isTableList,
        selectTableKey,
        timer,
        beforeFetch,
        searchKey: searchKey || nameKey,
        callback: (data: any[]) => {
          const result = filterData ? filterData(data) : data;
          setLoading(false);
          setOptions([...result]);
          onSuccess?.(result);
        },
      });
    }, delayTime);
  };
  // 获取焦点
  const handleFocus = () => {
    if (!selectValue || (Array.isArray(selectValue) && !selectValue.length)) {
      setOptions([]);
      handleSearch('', 0);
      return;
    }
    // if (mode === 'multiple' && selectValue && !selectValue.length) {
    //   setOptions([]);
    //   handleSearch('', 0);
    //   return;
    // }
  };
  const handleValueChange = (value: any) => {
    const keys: any[] = value ? (mode === 'multiple' ? value : [value]) : [];
    setTableKeys(keys);
    const currentDatasource: any[] = visible
      ? tableRef.current?.getDataSource() || []
      : options;
    onChange &&
      onChange(
        value,
        currentDatasource.filter(v => keys.includes(v[valueKey])),
      );
  };
  // 选中
  const handleChange = (value: any) => {
    setSelectValue(value);
    if (showMore && (!value || !value.length)) handleSearch('');
    handleValueChange(value);
  };
  // 查看更多
  const handleMore = () => {
    if (selectRef.current) {
      selectRef.current.blur();
      setVisible(true);
    }
  };
  // 本地搜索
  const handleFilterOption = (inputValue: string | number, option: any) => {
    if (showMore) return option;
    return option.label?.includes(inputValue);
  };
  const optionsNode = useCallback(() => {
    return options.map(v => {
      return (
        <ProSelect.Option
          key={v[valueKey]}
          value={v[valueKey]}
          label={v[nameKey]}
        >
          {renderOption ? renderOption(v) : v[nameKey]}
        </ProSelect.Option>
      );
    });
  }, [options, valueKey, nameKey]);
  const handleCancel = () => setVisible(false);
  const handleOk = (selectedRowKeys?: Key[], selectedRows?: any[]) => {
    if (selectedRowKeys && selectedRows) {
      const keys = mode === 'multiple' ? selectedRowKeys : selectedRowKeys[0];
      setSelectValue(keys);
      setTableKeys(selectedRowKeys);
      const otherOptions: any[] = [];
      selectedRows.forEach(row => {
        if (!options.find(item => item[valueKey] === row[valueKey]))
          otherOptions.push(row);
      });
      setOptions([...options, ...otherOptions]);
      initOptionsCacheRef.current = [
        ...initOptionsCacheRef.current,
        otherOptions,
      ];
      handleCancel();
      onChange?.(keys, selectedRows);
    }
  };
  const handleClear = () => {
    const emptyValue = mode === 'multiple' ? [] : '';
    handleChange(emptyValue);
  };
  return (
    <div className={className} style={style}>
      <ProSelect
        {...resProps}
        allowClear={allowClear}
        ref={selectRef}
        mode={mode}
        style={style}
        showSearch={showSearch}
        value={selectValue}
        filterOption={handleFilterOption}
        loading={loading}
        onSearch={(val: string) =>
          showMore ? handleSearch(val, delay) : undefined
        }
        getPopupContainer={getPopupContainer}
        onChange={handleChange}
        onFocus={handleFocus}
        onClear={handleClear}
        optionLabelProp="label"
        disabled={disabled}
        maxTagPlaceholder={omittedValues => {
          return `+${omittedValues.length}`;
        }}
        dropdownRender={menu => (
          <div>
            {menu}
            {showMore && (
              <div
                className={`${styles.more} select-table-move`}
                onClick={handleMore}
              >
                {moreText}
              </div>
            )}
          </div>
        )}
      >
        {optionsNode()}
      </ProSelect>
      {showMore && columns && (
        <ModalTable
          nameKey={nameKey}
          hideTab={false}
          modalProps={{
            visible,
            size: modalSize,
            wrapClassName: modalClassName,
            onOk: handleOk,
            onCancel: handleCancel,
            destroyOnClose: false,
            getContainer: getPopupContainer,
          }}
          tableProps={{
            actionRef: tableRef,
            formItems: formItems,
            listApi: fetchApi,
            rowKey: valueKey,
            columns: columns,
            maxItemLength: maxItemLength,
            rowSelectionType: mode === 'multiple' ? 'checkbox' : 'radio',
            selectedInfo: {
              selectedRowKeys: tableKeys,
              selectedRows: options.filter(v =>
                tableKeys.includes(v[valueKey]),
              ),
            },
            operationProps: operationProps,
            defauleSearchParams: otherParams,
            groupFields: groupFields,
            onBefore: (params: any) => {
              if (beforeFetch) return beforeFetch(params);
              return params;
            },
          }}
        />
      )}
    </div>
  );
};

SelectTable.defaultProps = {
  style: { width: 200 },
  showSearch: true,
  allowClear: true,
  delay: 300,
  moreText: '选择更多',
  otherParams: {},
  disabled: false,
  showMore: true,
  dataKey: 'dataSource',
  isTableList: true,
  maxTagCount: 1,
  maxTagTextLength: MAX_TAG_TEXT_LENGTH,
  initLoad: false,
};

export default SelectTable;
